// Country value format helpers.
//
// The profile country field changed format over time:
//   - Legacy (pre-geo) registration stored the country NAME ("Argentina", "Brasil").
//   - The geo-detected flow stores the ISO 3166-1 alpha-2 CODE ("AR", "BR"),
//     consistent with the Country Registry in legend-social.
//
// The two formats are disjoint: only a canonical code is exactly two uppercase
// ASCII letters, so this check reliably tells a migrated profile from a legacy one
// without a backend round-trip or a mass data migration.

const ALPHA2_CODE = /^[A-Z]{2}$/;

/**
 * Whether `value` is a canonical ISO 3166-1 alpha-2 country code (the format the
 * geo-detected profile flow stores). Legacy country names ("Argentina") return
 * false, which is what marks a profile as needing re-completion.
 */
export function isCanonicalCountryCode(
  value: string | null | undefined,
): boolean {
  if (!value) return false;
  return ALPHA2_CODE.test(value.trim());
}
